<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from "vue-router"

import {useStore} from "vuex";

import TemplateBuilder from "@/Modules/TemplateBuilder/components/TemplateBuilder.vue";
import Loader from "@/components/Loader.vue";

const route = useRoute();
const store = useStore()

const isLoading = ref(false);
const currentTemplate = computed(() => store.getters['builder/getCurrentTemplate'])


onMounted(() => {
  isLoading.value = true
  Promise.all([
      store.dispatch('builder/getTemplate', route.params.id),
  ]).finally(() => isLoading.value = false)
})

</script>

<template>
  <Loader :is-loading="isLoading">
    <TemplateBuilder :id="route.params.id" :template="currentTemplate.content"/>
  </Loader>

</template>

<style scoped>

</style>